var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15.8423,
    r: 15,
    fill: "#68D585"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1117 20.5346C12.87 20.5346 12.6287 20.4439 12.4442 20.2619L8 15.8813L9.33504 14.5649L13.1117 18.2875L20.665 10.8423L22 12.1587L13.7792 20.2619C13.5946 20.4439 13.3534 20.5346 13.1117 20.5346Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check_icon.7feade28ac4c1f22b3e11e5619424762.svg";
export { ForwardRef as ReactComponent };